// extracted by mini-css-extract-plugin
var _1 = "Puyi5__entry";
var _2 = "Puyi5__entry__header";
var _3 = "Puyi5__stats";
export { _1 as "entry", _2 as "entry__header", _3 as "stats" }
